<nav class="sidebar">
  <!-- Logo/Brand -->
  <div class="sidebar-header">
    <div class="brand">
      <img [src]="getBrandLogo()" alt="" class="brand-logo" (error)="useCompanyLogo($event)">
      <h2 *ngIf="!isCollapsed">{{ getBrandName() }}</h2>
      <button
        class="collapse-toggle"
        type="button"
        [attr.aria-label]="isCollapsed ? 'Expand menu' : 'Collapse menu'"
        [title]="isCollapsed ? 'Expand menu' : 'Collapse menu'"
        (click)="toggleCollapsed()">
        <i class="material-icons">{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</i>
      </button>
    </div>
    <div class="user-info" *ngIf="currentUser">
      <div class="user-avatar">
        {{ getDisplayName().charAt(0) }}
      </div>
      <div class="user-details" *ngIf="!isCollapsed">
        <strong>{{ getDisplayName() }}</strong>
        <span class="user-role">{{ getRoleLabel() }}</span>
      </div>
    </div>
  </div>

  <!-- Navigation Menu -->
  <ul class="sidebar-menu">
    <li *ngFor="let item of getNavItems()">
      <a *ngIf="!item.children"
         [routerLink]="item.path"
         routerLinkActive="active"
         [title]="isCollapsed ? item.label : null">
        <i class="material-icons">{{ item.icon }}</i>
        <span *ngIf="!isCollapsed">{{ item.label }}</span>
      </a>
      <div *ngIf="item.children" class="nav-group" [class.active]="isNavGroupActive(item)">
        <button class="nav-group-label" type="button" [title]="isCollapsed ? item.label : null" [attr.aria-expanded]="isGroupExpanded(item)" (click)="toggleGroup(item)">
          <i class="material-icons">{{ item.icon }}</i>
          <span *ngIf="!isCollapsed">{{ item.label }}</span>
          <i class="material-icons group-chevron" *ngIf="!isCollapsed">{{ isGroupExpanded(item) ? 'expand_less' : 'expand_more' }}</i>
        </button>
        <ul class="nav-submenu" *ngIf="!isCollapsed && isGroupExpanded(item)">
          <li *ngFor="let child of item.children">
            <a [routerLink]="child.path" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: child.path === '/dashboard/utilities' }">
              <i class="material-icons">{{ child.icon }}</i>
              <span>{{ child.label }}</span>
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>

  <!-- Bottom Actions -->
  <div class="sidebar-footer">
    <a href="#" class="nav-item" [title]="isCollapsed ? 'Logout' : null" (click)="logout(); $event.preventDefault()">
      <i class="material-icons">logout</i>
      <span *ngIf="!isCollapsed">Logout</span>
    </a>
  </div>
</nav>
